// extracted by mini-css-extract-plugin
module.exports = {"background":"Gallery_background__zP1gn","button":"Gallery_button__T5_Bh","gallery":"Gallery_gallery__h23fg","slider":"Gallery_slider__hn4IP"};